module.exports = __webpack_public_path__ + "static/media/1.0b2aa3ac.png";